import type { SelectraQuestion } from 'src/types/Selectra';

export const parseValidationRegex = (validation?: string): RegExp | null => {
	if (!validation) return null;

	const match = validation.match(/^regex:\/(.*)\/$/);
	return match ? new RegExp(match[1]) : null;
};

export const toSelectOptions = (options: Record<string, string> = {}) =>
	Object.entries(options).map(([value, title]) => ({ title, value }));

export const isSameQualificationStep = (
	current: SelectraQuestion | null,
	next: SelectraQuestion | null,
): boolean => Boolean(current?.field && next?.field && current.field === next.field);

/**
 * True when the server moved past the submitted field. Same-field responses are
 * retries / re-asks and must keep the current tab.
 */
export const shouldAdvanceQualificationStep = (
	submitted: SelectraQuestion | null,
	next: SelectraQuestion | null,
	done: boolean,
): boolean => {
	if (done) return true;

	return Boolean(next?.field) && !isSameQualificationStep(submitted, next);
};

/**
 * Puts `question` at `stepIndex` (refreshing labels/options) and drops any
 * later tabs so retries and country-branch changes reuse the same slot.
 */
export const upsertQualificationStep = (
	history: SelectraQuestion[],
	question: SelectraQuestion,
	stepIndex: number,
): SelectraQuestion[] => {
	const nextHistory = history.slice(0, stepIndex);
	nextHistory[stepIndex] = question;
	return nextHistory;
};
